<template>
  <div
    v-if="isVisible"
    class="absolute top-20 right-10 w-80 z-50 p-4 rounded-md shadow-lg relative"
    style="background-color: #dbeafe; border: 2px solid #3b82f6; position: absolute !important"
  >
    <button
      @click="dismiss"
      class="absolute top-2 right-2 text-blue-700 hover:text-blue-900 font-bold text-xl leading-none"
      aria-label="Close"
    >
      ×
    </button>
    <h1 class="text-blue-900 font-bold text-center mb-2">Good News!</h1>
    <p class="text-sm text-blue-800 mb-2">
      I've found a new way to get the app running again! The raffle app is now
      functional, but please note that it's still being tested.
    </p>
    <p class="text-sm text-blue-800 mb-2">
      If you encounter any issues or unexpected behavior, please let me know. Your
      feedback will help improve the stability of the app.
    </p>
    <p class="text-xs text-blue-700 italic text-center mt-3">
      Thank you for your patience!
    </p>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const STORAGE_KEY = "toyhouse_raffle_app_status_dismissed";
const isVisible = ref(false);

onMounted(() => {
  const dismissed = localStorage.getItem(STORAGE_KEY);
  isVisible.value = dismissed !== "true";
});

const dismiss = () => {
  isVisible.value = false;
  localStorage.setItem(STORAGE_KEY, "true");
};
</script>

